import {Routes} from '@angular/router';

import {AuthPageGuardService, PrivatePageGuardService} from 'shared/services';
import {AuthLayoutComponent} from './layouts/auth/auth-layout.component';
import {MainLayoutComponent} from './layouts/main/main-layout.component';
import {Error404Component} from './common/error404/error404.component';
import {SignInComponent} from './auth/sign-in/sign-in.component';
import {OrganizationComponent} from './auth/organization/organization.component';
import {LogoutComponent} from './auth/logout/logout.component';

export const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    // canActivate: [AuthPageGuardService],
    children: [
      {
        path: '',
        component: SignInComponent,
        canActivate: [AuthPageGuardService],
      },
      // {path: 'sign-up', component: SignUpComponent},
      // {path: 'forgot-password', component: ForgotPasswordComponent},
      // {path: 'reset-password', component: ResetPasswordComponent},
      // {path: 'lock-screen', component: LockScreenComponent},
      // {path: 'confirm-email', component: ConfirmEmailComponent},
      {
        path: 'organization',
        component: OrganizationComponent,
        canActivate: [PrivatePageGuardService],
      },
      {
        path: 'logout',
        component: LogoutComponent,
        canActivate: [PrivatePageGuardService],
      },
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [PrivatePageGuardService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        // @TODO
        // redirectTo: 'home',
        redirectTo: 'tournaments',
      },
      {
        path: 'home',
        loadComponent: () => import('home').then((m) => m.Home),
      },
      // {
      //   path: 'admin',
      //   children: [
      //     {
      //       path: '',
      //       pathMatch: 'full',
      //       redirectTo: 'locations',
      //     },
      //     {
      //       path: 'locations',
      //       loadComponent: () => import('@locations').then((m) => m.LocationsComponent),
      //     },
      //     {
      //       path: 'courts',
      //       loadComponent: () => import('@courts').then((m) => m.CourtsComponent),
      //     },
      //     {
      //       path: 'events',
      //       loadComponent: () => import('@admin/events').then((m) => m.AdminEventsComponent),
      //     },
      //     {
      //       path: 'tournaments',
      //       children: [
      //         {
      //           path: '',
      //           loadChildren: () => import('@admin/tournaments').then((m) => m.routes),
      //         },
      //       ],
      //     },
      //     {
      //       path: 'players',
      //       loadComponent: () => import('@admin/players').then((m) => m.AdminPlayersComponent),
      //     },
      //   ],
      // },
      // {
      //   path: 'rankings',
      //   children: [
      //     {
      //       path: '',
      //       loadChildren: () => import('@events').then((m) => m.routes),
      //     },
      //   ],
      // },
      {
        path: 'tournaments',
        children: [
          {
            path: '',
            loadChildren: () => import('tournaments').then((m) => m.routes),
          },
        ],
      },
    ],
  },
  // {
  //   path: '',
  //   loadComponent: () => import('@app/home').then((m) => m.HomeComponent),
  // },
  // {
  //   path: 'users',
  //   loadComponent: () => import('@app/users').then((m) => m.UsersComponent),
  // },

  // Not found
  {
    path: '**',
    // redirectTo: '404',
    component: Error404Component,
  },
];
